import { tokens } from '../../theme/tokens';

const { surface, line, ink, signal, radius, shadow, font } = tokens;

/**
 * Design tokens for the Brand Home dashboard.
 *
 * Originally transcribed from the "Brand Home" handoff, whose muted signal
 * colours were a deliberate choice against MUI's saturated defaults. That
 * muted set is now the app-wide one in `theme/tokens.ts`, so this file only
 * maps the handoff's names onto it.
 */
export const brandHome = {
  color: {
    surface: surface.card,
    subtleSurface: surface.subtle,
    border: line.strong,
    hairline: line.hairline,
    rowHairline: line.faint,
    chipFill: surface.tint,
    ink: ink.primary,
    body: ink.body,
    bodyAlt: ink.bodyAlt,
    muted: ink.muted,
    faint: ink.faint,

    positiveInk: signal.positive.ink,
    positiveSolid: signal.positive.solid,
    positiveTint: signal.positive.tint,
    positiveBorder: signal.positive.border,

    cautionInk: signal.caution.ink,
    cautionSolid: signal.caution.solid,
    cautionSolidAlt: signal.caution.solid,
    cautionTint: signal.caution.tint,
    cautionBorder: signal.caution.border,
    cautionRow: signal.caution.row,

    problemInk: signal.problem.ink,
    problemSolid: signal.problem.solid,
    problemTint: signal.problem.tint,
    problemBorder: signal.problem.border,
    problemRow: signal.problem.row,

    infoInk: signal.info.ink,
    infoSolid: signal.info.solid,
    infoTint: signal.info.tint,
    infoBorder: signal.info.border,

    neutralInk: signal.neutral.ink,
    neutralSolid: signal.neutral.solid,
    neutralTint: signal.neutral.tint,
    neutralBorder: signal.neutral.border,
  },
  font: {
    sans: font.sans,
    mono: font.mono,
  },
  radius: {
    card: radius.card,
    kpi: radius.card,
    inset: radius.control,
    control: radius.small,
    smallButton: radius.small,
    chip: radius.chip,
    pill: radius.pill,
  },
  shadow: {
    card: shadow.card,
  },
} as const;
